import { translatePanels } from 'components/ManualToolModal/api';
import { getAbsolutePointsOfTranslatedPanels, getPitchChangeForRoofs } from 'components/ManualToolModal/util';
import { useRefs } from 'contexts/RefContext';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { useMutation } from 'react-query';
import { AxiosError } from 'axios';
import { useKonvaImageScale } from 'contexts/ToolDimensionsAndScaleContext';
import { appToast } from 'components/Basic/CustomToast';
import { errorResponseHandler } from 'store/api/AxiosError';

export default function useTranslatePanelPositionsMutation() {
	const { panel, uuid, allRoofSegs, designType, mode } = useSelector((state: RootState) => state.roofData.data);
	const { roofIndexes } = useSelector((state: RootState) => state.toolNewPostions.data);
	const scale = useKonvaImageScale();
	const { konvaRef } = useRefs();
	const solarDesign = designType === 'SOLAR';

	const translatePanelPositionsMutation = useMutation(
		async () => {
			if (!konvaRef?.current) return;
			const newTranslatedPositions = solarDesign ? getAbsolutePointsOfTranslatedPanels(konvaRef.current, roofIndexes, allRoofSegs, scale, mode)
				: getPitchChangeForRoofs(konvaRef.current, roofIndexes, allRoofSegs);
			if (!newTranslatedPositions.length) throw new Error('E_NO_TRANSLATIONS_TO_SAVE');
			return await translatePanels(newTranslatedPositions, panel.key, uuid, solarDesign);
		},
		{
			mutationKey: 'translate-panels',
			onError(error: AxiosError) {
				if (error.message === 'E_NO_TRANSLATIONS_TO_SAVE') return;
				appToast.error(errorResponseHandler(error).message || 'Something went wrong, please try again');
			},
		});

	return translatePanelPositionsMutation;
}
